/* Viewport height is taller than the visible part of the document in some mobile browsers */
/* Instead of 'vh' units in css we calculate viewport height and set css variable with js */

const setViewportHeight = () => {
  document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
};

window.addEventListener('resize', setViewportHeight);
document.addEventListener('turbolinks:load', setViewportHeight);
